// extracted by mini-css-extract-plugin
module.exports = {"section":"section-vZCuyK-8YlTct1cjZe-fG","header":"header-24J_Usx_4o5O3052mIqHuS","content":"content-1UWGOpKbe8BlN6GtYgzGdd"};